import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {tagsList_template} from "../components/templates/tagsList_template";
import {vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";
import {tagRatingsList_template} from "../components/templates/tagRatingsList_template";
import {getAllBrandsFromVnAppZone} from "../utils/BrandHelper";

declare var ko: any;
declare var page: any;

export class tagRatings extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected elementsList: tagRatingsList_template;
    protected pagination: pagination_template;

    protected getModuleName(){

        return "tagRatings";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.elementsList = new tagRatingsList_template("list", this.viewModel, this);
        this.template = this.elementsList;

        //only show Add Job Profile button if CM or Admin
        let vnApp = this.getVnAppZone().app;
        let roles = vnApp.loggedUser.user.valnet_user.roles;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Tag Ratings List");


        if (this.isBrand()) {
            this.elementsList.setBrandId(this.getBrandId());
        } else {

            this.elementsList.setBrandId(undefined);
        }

        return [this.elementsList.build()];
    }

    public fillPage() : void{

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand) {
            this.elementsList.setBrandId(idBrand);
        }

        this.elementsList.setReviewerTypeFilterItems([
            {id: 1, name: "Valnet Access Users"},
            {id: 0, name: "Non-Valnet Access Users"},
        ]);

        this.elementsList.setBrandFilterItems(getAllBrandsFromVnAppZone(this.getVnAppZone()));

        this.updateViewModelFromPath();

        this.filterByUrl();

    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected ratingsListReorder(){

        this.filterList();
    }

    protected filterDropdownOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange(){
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected getMemoryViewModel(){
        let templateViewModel = this.elementsList.getTemplateViewModel();

        delete templateViewModel.tagTypes;

        return templateViewModel;
    }

    protected filterByUrl(){

        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let subViewModel = this.elementsList.getViewModelForRequest();

        let usrReq_url: string = this.buildListRequestUrl();

        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.sendFilterCall(
            usrReq_url,
            subViewModel,
            this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET,
            'tags-list',this.elementsList.builtTemplate.children.namedItem("list-results")
        );
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
            });
            obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected onAutocompleteInputClick(idElement) {

        if ( idElement == "datasetFilterAutocomplete" )
        {
            let filterTypes = this.elementsList.reviewerFilter.getTemplateViewModel();

            if (filterTypes.addNewSelected())
            {
                this.elementsList.reviewerFilter.setOptions([]);
            }
        }
    }

    public getReviewerSuggestion(keyword, idElement) {

        if( "getReviewerSuggestions" in this.XHRHdls ){
            this.XHRHdls["getReviewerSuggestions"].cancelAndReset();
        }

        // LOADING : starts

        let subViewModel = {list: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + "/search/user/";
        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getReviewerSuggestions']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getReviewerSuggestions'].onReadyStateFunction = this.onReviewerSuggestionReturn;
        this.XHRHdls['getReviewerSuggestions'].execute();
    }

    protected onReviewerSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data.users) {
                    const suggs = response.data.users;
                    let reviewers = [];
                    for (let i=0;i<suggs.length;i++) {
                        reviewers[i] = {};
                        reviewers[i].id = suggs[i].id;
                        if (suggs[i].displayName && suggs[i].displayName.tring !== "") {
                            reviewers[i].name = suggs[i].displayName;
                        } else if (suggs[i].fullName && suggs[i].fullName.tring !== "") {
                            reviewers[i].name = suggs[i].fullName;
                        } else if (suggs[i].firstName && suggs[i].firstName !== "" && suggs[i].lastName && suggs[i].lastName !== "") {
                            reviewers[i].name = suggs[i].firstName + " " + suggs[i].lastName;
                        } else if (suggs[i].email && suggs[i].email !== "") {
                            reviewers[i].name = suggs[i].email;
                        }
                    }
                    obj.elementsList.reviewerFilter.setOptions(reviewers);
                }
            });
        }
    }

    protected getSuggestions(keyword, idSourceElement) {
        if (idSourceElement == "reviewerFilter") {
            this.getReviewerSuggestion(keyword, idSourceElement);
        }
    }

    protected onAutocompleteOptionChange(idElement) {
        if (idElement == "reviewerFilter") {
            this.filterList();
        }
    }

    protected onAutocompleteInputClear(idElement) {
        if (idElement == "reviewerFilter") {
            this.elementsList.reviewerFilter.setOptions([]);
            this.filterList();
        }
    }

    public setViewModelFromRequest(urlParams) {
        this.elementsList.setViewModelFromRequest(urlParams);
    }

    // update the module list using the objects list
    protected updateList(responseParsed: any){

        let mainUrl = '/categorization/tag-ratings/view/';
        if (this.isBrand()) {
            mainUrl = '/brand/' + this.getBrandId() + '/categorization/tag-ratings/view/';
        }
        // set Jobs list
        let tagRatingsToSet = [];
        for (let item of responseParsed.data) {
            tagRatingsToSet.push( {
                id: item.id,
                idWebsiteUser: item.idWebsiteUser,
                reviewerName: item.reviewerName,
                reviewerType: item.reviewerType,
                reviewerEmail: item.reviewerEmail,
                idTag: item.idTag,
                tagName: item.tagName,
                tagSlug: item.tagSlug,
                tagType: item.tagType,
                brandName: item.brandName,
                brandShortName: item.brandShortName,
                brandIconImage: item.brandIconImage,
                rating: item.rating,
                commentText: item.commentText,
                dateCreated: item.dateCreated,
                dateUpdated: item.dateUpdated,
                emakiView: mainUrl + item.id,
            });
        }

        this.elementsList.setTagRatings(tagRatingsToSet);

        let usrReq_url: string = this.buildListRequestUrl() + "-tags-list";

        let execTime = Math.round((new Date().getTime() - this.XHRHdls[usrReq_url].requestStartTime)/1000*100)/100;
        this.elementsList.setResultInfo(responseParsed.totalCount, responseParsed.totalPage, execTime);

        // update the paginator
        this.viewModel.list.pagination.itemCount(responseParsed.totalCount);
    }

    protected viewTagRating(id){

        this.saveViewModule(this.getMemoryViewModel());
        let url = this.buildViewRequestUrl(id);
        page(url);
    }

    protected buildListRequestUrl(): string {

        let usrReq_url: string = '/api/tags/ratings/get';

        if (this.isBrand()) {

            let brandId = this.getBrandId();
            usrReq_url = '/api/brand/' + brandId + '/tags/ratings/get';
        }
        return usrReq_url;
    }


    protected buildViewRequestUrl(id: number): string {

        let url = '/categorization/tag-ratings/view/' + id;

        if (this.isBrand()) {

            let brandId = this.getBrandId();
            url = '/brand/' + brandId +'/categorization/tag-ratings/view/' + id;
        }
        return url;
    }

    protected buildSaveRatingUrl(): string {

        let usrReq_url: string = '/api/tags/ratings/save/';

        if (this.isBrand()) {

            let brandId = this.getBrandId();
            usrReq_url = '/api/brand/' + brandId + '/tags/ratings/save/';
        }
        return usrReq_url;
    }

    protected buildSearchTagUrl(): string {

        let usrReq_url: string = '/api/search/tag/';

        if (this.isBrand()) {

            let brandId = this.getBrandId();
            usrReq_url = '/api/brand/' + brandId + '/search/tag/';
        }
        return usrReq_url;
    }

    public isBrand(): boolean {

        let number = Number(this.getBrandId());
        return Number.isInteger(number);
    }

    public getBrandId(): number {

        return Number(this.getVnAppZone().app.params.idBrand);
    }

    public getTagsSuggestion(keyword, idElement) {

        if( "getTagsSuggestion" in this.XHRHdls ){
            this.XHRHdls["getTagsSuggestion"].cancelAndReset();
        }

        let subViewModel = {pagination: {itemPerPage: 25}, filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = this.buildSearchTagUrl();
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getTagsSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls["getTagsSuggestion"].onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdls["getTagsSuggestion"].execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);

                if (response.data.tags) {

                    obj.elementsList.setTagFilter(response.data.tags);
                }

            });
        }
    }

    protected getTagTypesSuggestion(keyword,idElement){
        if( "getTagTypesSuggestion" in this.XHRHdls ){
            this.XHRHdls["getTagTypesSuggestion"].cancelAndReset();
        }
        const subViewModel = {filter: {keyword: keyword}, idElement: idElement};
        let usrReq_url: string = "/api/search/tag/type/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getTagTypesSuggestion']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getTagTypesSuggestion'].onReadyStateFunction = this.onGetTagTypesSuggestionReturn;
        this.XHRHdls['getTagTypesSuggestion'].execute();
    }

    protected onGetTagTypesSuggestionReturn(req, obj){
        return function () {
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                const tagTypes = responseParsed.data.tagTypes;
                obj.elementsList.setTagTypeFilter(tagTypes)

            });
        }
    }

    protected editRating(){

        this.loadingIn(this.elementsList.builtTemplate);

        let formReq_url: string = this.buildSaveRatingUrl();
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = this.elementsList.getViewModelForSave();
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {
                obj.manageResponse(req, obj, function () {
                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Rating Saved!");
                        obj.getVnAppZone().showNotificationToModule();
                        obj.elementsList.onClickHidePopUp();
                        obj.filterList();
                    }
                });
                obj.loadingOut(obj.elementsList.builtTemplate);
            }
        });
        XHRHdl.execute();
    }
}



// WEBPACK FOOTER //
// ./js/modules/tagRatings.ts